
import WDModelItems from '../wd-model-items';
import WDCheckButton from '../button/wd-check-button';
import { WDModelArray } from '../../core/wd-model';
import WDUtil from '../../core/wd-util';

export default class WDChecklist extends WDModelItems
{
	#values = [];

	constructor(cfg)
	{
		const baseConfig = {
			data: [],
			multiple: false,
			allowClear: true,
			separator: ', ',
		};

		WDUtil.merge(baseConfig, cfg);

		super(baseConfig);
		this.classList.add('wd-checklist');

		//setup our base proxy for our option storage
		this.#values = new WDModelArray([]);
		this.on('item:selected', evt => this.handleItemSelected(evt));
		this.on('value:set',() => this.updateCheckedRows());

		//
		if (this.config?.value !== undefined) this.value = this.config.value;

		return this;
	};

	createModelItem(data)
	{
		const labelStr = this.config.templates.label.interpolate(data);

		const item = new WDCheckButton({ label: labelStr });
		item.classList.add('dropdown-item');
		item.classList.remove('btn');
		item.tabIndex = '-1';
		item.model = data;

		item.value = this.config.templates.value.interpolate(data);
		const hasMatch = this.#values.find(x => x == item.value);
			
		//check it if set.  Note: can't use array.includes because
		//sometimes could be string compared to int for a number
		if (hasMatch !== undefined) item.checked = true;
		
		this.addModelItemEvents(item);

		return item;
	}

	addModelItemEvents(item)
	{
		//watch for changes
		item.on('click', (evt) =>
		{
			this.trigger('item:selected', item);
		});

		// Keyboard navigation
		item.on('keydown', (e) =>
		{
			if (e.key === 'Enter') 
			{
				e.preventDefault();	//stops the keyboard from beeping on enter
				this.trigger('item:selected', item);
			}
			/* don't need anymore?
			else if (e.key == 'ArrowDown' || e.key == 'ArrowUp')
			{
				e.preventDefault();
			}
			*/
		});
	};

	updateCheckedRows()
	{
		const values = this.#values.toArray();

		this.itemArray.forEach(item =>
		{
			const hasMatch = values.find(x => x == item.value);
			item.checked = hasMatch != null;
		});
	};

	handleItemSelected(evt)
	{
		const item = evt.detail;
		const val = String(item.value).isNumeric() ? Number(item.value) : item.value;
		const idx = this.#values.indexOf(val);

		if (this.config.multiple)
		{
			if (idx == -1)
			{
				this.#values.push(val);
			} else
			{
				this.#values.splice(idx, 1);
			}

			this.trigger('value:set change');
		}
		else
		{
			const idx = this.#values.indexOf(val);
			const shouldClear = this.config.allowClear && idx !== -1;
			const newVal = shouldClear ? [] : [val];

			this.value = newVal;
			this.trigger('change');		//item:selected means it was a user-interaction so change
		}

	};

	get value()
	{
		if (this.config.multiple == true)
		{
			return this.#values;
		}
		else
		{
			return (this.#values.length > 0) ? this.#values[0] : null;
		}
	};

	set value(val)
	{
		if (val === null) val = [];
		else if (!(val instanceof Array)) val = [val];

		this.#values.replace(val);
		this.trigger('value:set');
	};

	set valueLabel(lbls)
	{
		lbls = Array.isArray(lbls) ? lbls : [lbls];

		const setValuesFromLabels = () =>
		{
			const vals = this.model
				.filter(opt => lbls.includes(opt.label))
				.map(opt => opt.value);
			if (vals.length > 0) this.value = vals;
		};

		return new Promise(resolve =>
		{
			if (this.model.length > 0)
			{
				setValuesFromLabels();
				resolve(true);
			} else
			{
				this.one('model:set', () =>
				{
					setValuesFromLabels();
					resolve(true);
				});
			}
		});
	}

	/**
	 * Generates a label based on all the selected values in the list
	 */
	get valueLabel()
	{
		const labels = this.#values.map(v => {
				const opt = this.model.find(data => {
					const optVal = this.config.templates.value.interpolate(data);
					return String(optVal) == String(v);
				});
				
				return opt ? this.config.templates.label.interpolate(opt) : null;
			})
			.filter(label => label !== null);

		if (labels.length === 0) return null;

		if (typeof labels[0] === 'object')
		{
			const container = wdc('<div/>');
			labels.forEach(label => container.append(label.cloneNode(true)));
			return container;
		}
		return labels.join(this.config.separator);
	}

};

customElements.define('wd-checklist', WDChecklist);
